export const getTrimedS3Url = (url: string) => {
  const trimedUrl = url
    ? url.replace('https://s3-ap-southeast-1.amazonaws.com/carro.co/', '')
    : url;
  return trimedUrl;
};

export default { getTrimedS3Url };
